import request from '@/utils/request';

// 填写报名表
export function signUpForm(data) {
  return request({
    url: '/userSignUp/form',
    method: 'post',
    data,
  });
}
//查询指标信息
export function queryIndex(data) {
  return request({
    url: '/userSignUp/queryIndex',
    method: 'get',
    params: data,
  });
}
//查询报名表详情
export function getFormDetail(data) {
  return request({
    url: '/userSignUp/getForm',
    method: 'get',
    params: data,
  });
}
//查询科目
export function getSubject(data) {
  return request({
    url: '/userSignUp/getSubject',
    method: 'get',
    params: data,
  });
}
//查询专业
export function getMajor(data) {
  return request({
    url: '/userSignUp/getMajor',
    method: 'get',
    params: data,
  });
}
//查询考点
export function getExamPoint() {
  return request({
    url: '/userSignUp/getExamPoint',
    method: 'get',
  });
}
//查询报名点
export function getExamRegistrationPoint(data) {
  return request({
    url: '/userSignUp/getExamRegistrationPoint',
    method: 'get',
    params: data,
  });
}
//确认报名
export function signUpConfirm(data) {
  return request({
    url: '/userSignUp/confirm',
    method: 'get',
    params: data,
  });
}
//预览报名表
export function previewForm(params) {
  return request({
    url: '/userSignUp/previewForm',
    method: 'post',
    params,
    responseType: 'blob',
  });
}
//修改报考信息
export function updateExamInfo(data) {
  return request({
    url: '/userSignUp/update/examInfo',
    method: 'post',
    data,
  });
}
//修改报名信息以及身份信息
export function updateIdentity(data) {
  return request({
    url: '/userSignUp/update/identity',
    method: 'post',
    data,
  });
}
//打印报名表 1为报名表 2为准考证
export function printForm(data) {
  return request({
    url: '/userSignUp/print/registrationForm',
    method: 'get',
    params: data,
  });
}
//查询考试设置
export function queryExamReviewConfig(data) {
  return request({
    url: '/userSignUp/queryExamReviewConfig',
    method: 'get',
    params: data,
  });
}
//查询考试内容时间地点
export function queryTimeAndAddress(data) {
  return request({
    url: '/userSignUp/queryTimeAndAddress',
    method: 'get',
    params: data,
  });
}
//查询我的考生记录
export function queryMyExamList() {
  return request({
    url: '/userSignUp/queryMyExamList',
    method: 'get',
  });
}
//查询考试文件设置
export function queryExamFile(data) {
  return request({
    url: '/userSignUp/queryExamFile',
    method: 'get',
    params: data,
  });
}
//查询提示
export function queryTip(data) {
  return request({
    url: '/userSignUp/queryTip',
    method: 'get',
    params: data,
  });
}
//查询资料设置
export function queryInformationConfig(data) {
  return request({
    url: '/userSignUp/queryInformationConfig',
    method: 'get',
    params: data,
  });
}
//退回资料
export function returnInformation(data) {
  return request({
    url: '/userSignUp/returnInformation',
    method: 'get',
    params: data,
  });
}
//查询是否可以修改资料
export function isModifyInformation(data) {
  return request({
    url: '/userSignUp/isModifyInformation',
    method: 'get',
    params: data,
  });
}
//查询是否支付
export function queryIsPay(data) {
  return request({
    url: '/userSignUp/queryIsPay',
    method: 'get',
    params: data,
  });
}
//查询是否确定报名
export function queryIsSignUp(data) {
  return request({
    url: '/userSignUp/queryIsSignUp',
    method: 'get',
    params: data,
  });
}
//查询是否需要上传图片
export function queryPhotoConfig(data) {
  return request({
    url: '/userSignUp/queryPhotoConfig',
    method: 'get',
    params: data,
  });
}
//确认已读
export function confirmRead(data) {
  return request({
    url: '/userSignUp/confirmRead',
    method: 'get',
    params: data,
  });
}
//查询是否已读
export function queryIsRead(data) {
  return request({
    url: '/userSignUp/isRead',
    method: 'get',
    params: data,
  });
}
//查询准考证是否导入
export function queryIsImport(data) {
  return request({
    url: '/userSignUp/isImport',
    method: 'get',
    params: data,
  });
}
//查询是否需要支付
export function queryNeedPay(data) {
  return request({
    url: '/userSignUp/queryNeedPay',
    method: 'get',
    params: data,
  });
}
//查询需要展示的报考信息
export function queryShowExam(data) {
  return request({
    url: '/userSignUp/queryShowExam',
    method: 'get',
    params: data,
  });
}
//查询所有报名点
export function queryAllRegistrationPoint(data) {
  return request({
    url: '/userSignUp/queryAllRegistrationPoint',
    method: 'get',
    params: data,
  });
}
//根据报名点查询考点
export function queryExamPoint(data) {
  return request({
    url: '/userSignUp/queryExamPoint',
    method: 'get',
    params: data,
  });
}
//查询考试附件
export function queryAttachmentFile(data) {
  return request({
    url: '/userSignUp/queryAttachmentFile',
    method: 'get',
    params: data,
  });
}
//获取单元格信息
export function getCellAttribute(data) {
  return request({
    url: '/userSignUp/getCellAttribute',
    method: 'post',
    params: data,
  });
}
